import React, { useState } from 'react';
import { TESTIMONIALS } from '../data/mockData';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % TESTIMONIALS.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-2 text-xs font-semibold tracking-[0.2em] text-[#DAA520] border border-[#DAA520]/30 rounded-sm mb-4">
            TESTIMONIALS
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">
            What Our Clients Say
          </h2>
          <div className="w-12 h-0.5 bg-[#DAA520] mx-auto mb-4" />
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.slice(0, 3).map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-[#1a1a1a] rounded-lg p-8 border border-gray-800 hover:border-[#DAA520]/30 transition-all duration-500 group"
            >
              <Quote size={32} className="text-[#DAA520]/30 mb-4" />
              <p className="text-gray-300 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-2 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={14} className="fill-[#DAA520] text-[#DAA520]" />
                ))}
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-800">
                <div className="w-12 h-12 rounded-full bg-[#DAA520]/10 border border-[#DAA520]/30 flex items-center justify-center">
                  <span className="text-[#DAA520] font-bold text-sm">{testimonial.avatar}</span>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{testimonial.name}</div>
                  <div className="text-gray-500 text-xs">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
